class CountryDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CountryDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setTriggerAccessibility();
    this.setupCountryLinks();
  }

  setTriggerAccessibility() {
    const trigger = document.querySelector('[data-country-drawer-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(trigger);
    });
    trigger.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(trigger);
      }
    });
  }

  setupCountryLinks() {
    const links = this.querySelectorAll('.country-drawer__link');
    const form = this.querySelector('form');
    const input = this.querySelector('input[name="country_code"]');

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        if (input && form) {
          input.value = event.currentTarget.dataset.value;
          form.submit();
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add('active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CountryDrawer');
        const focusElement = this.querySelector('.country-drawer__inner') || this.querySelector('.country-drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    
    setTimeout(() => {
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }, 400);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('country-drawer', CountryDrawer);

